import React, { PropTypes } from 'react';
import { Link, hashHistory } from 'react-router'
import DataService from '../lib/DataService';
import SharedTools from '../lib/SharedTools';
import UserRoleStore from '../stores/UserRoleStore';
import UserRoleActions from '../actions/UserRoleActions';
import CurrentRoleStore from '../stores/CurrentRoleStore';
import CurrentRoleActions from '../actions/CurrentRoleActions';
import ReactDOM from 'react-dom';

// import '../../../../assets/stylesheets/common/newantd.less';
import { Button, Modal, Input, message, Row, Col, Table, Popover, Select, Switch, Icon, Spin, } from 'antd';
const Search = Input.Search;
const Option = Select.Option;
const schoolChangeConfirm = Modal.confirm;
import 'antd/dist/antd.css';

export default class RolesIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      roles: UserRoleStore.getState(),
      schools: this.toolUserRoles().schools,
      graduatedArray: this.toolUserRoles().graduatedArray,
      systemAdmin: UserRoleStore.getState().find((role) => role.associatName == 'system'),
      visible: false,
     };

    // bind this
    this.onRolesChange = this.onRolesChange.bind(this);

  }

  componentDidMount(){
      UserRoleStore.addChangeListener(this.onRolesChange);
      if (this.state.systemAdmin) {
        DataService.getAutoRepliesMedias().then(res => {
          this.setState({
            autoReplies: res,
            autoRepliesMedias: res
          })
        })
      }
  }
  componentWillMount(){
    CurrentRoleActions.deleteCurrentUserRole();
  }

  componentWillUnmount(){
      UserRoleStore.removeChangeListener(this.onRolesChange);
  }

  toolUserRoles() {
    let userRoles = UserRoleStore.getState().filter((role) => role.associatName != 'system');
    let schools = [], graduatedArray = [];

    if (userRoles.length > 0) {
      schools[0] = {admin: [], teacher: [], parent: [], schoolName: userRoles[0].associatObj.schoolName, schoolId: (userRoles[0].associatName == 'school' ? userRoles[0].associatObj.id : userRoles[0].associatObj.schoolId)};
    }
    userRoles.forEach((role) => {
      let hasState = false;
      if (role.associatName == 'school') {
        role.associatObj.schoolId = role.associatObj.id
      }
      schools.map((school, index) => {
        if (role.associatObj.is_graduated) {
          graduatedArray.push(role);
          hasState = true;
        } else if (role.associatObj.schoolId == school.schoolId) {
          this.toolRoleInfo(schools, role, index)
          hasState = true;
        }
      })
      if (!hasState) {
        let key = schools.length;
        schools[key] = {admin: [], teacher: [], parent: [], schoolName: role.associatObj.schoolName, schoolId: role.associatObj.schoolId};
        this.toolRoleInfo(schools, role, key)
      }
    })
    return { schools, graduatedArray };
  }

  toolRoleInfo(schools, role, key) {
    if (role.associatName == 'student') {
      schools[key].parent.push(role);
    }
    else if (role.associatName == 'school' || role.associatName == 'classGrade') {
      schools[key].admin.push(role);
    } else if (role.associatName != 'system'){
      schools[key].teacher.push(role);
    }

  }

  onRolesChange() {
    this.setState({
      roles: UserRoleStore.getState()
    });
  }

  onSelectOneRole(role) {
    CurrentRoleActions.setCurrentUserRole(role.key);
    let path;
    switch (role.associatName) {
      case 'system':
        path = `albums/admin`;
        break;
      case 'student':
        path = `albums/index?studentId=${role.associatObj.id}`;
        break;
      case 'school':
        path = `albums/manage`;
        break;
      case 'classGrade':
        path = `albums/manage?gradeId=${role.associatObj.id}`;
        break;
      case 'classRecord':
        path = `albums/index?classId=${role.associatObj.id}&isClassAdmin=${role.associatObj.isClassAdmin}`;
        break;
    }
    hashHistory.push(path);
  }

  showModal(visible) {
    if (!visible) {
      this.setState({
        visible,
        searchType: 'school',
        value: '',
        searchSchoolResult: [],
        hasSearched: false
      })
    } else {
      this.setState({
        visible
      })
    }
  }



  selectClassRecord(index) {
    this.state.graduatedArray.map((classRecord, key) => {
      if (key == index) {
        classRecord.selected = true
      }
    });
    this.setState({
      graduatedArray: this.state.graduatedArray
    })
  }

  onSelectOneGraduatedRole() {
    let role;
    this.state.graduatedArray.map((classRecord) => {
      if (classRecord.selected) {
        role = classRecord;
      }
    });
    if (role) {
      this.onSelectOneRole(role)
    } else {
      message.info('请选择需要查看的班级')
    }
  }

  hideModal() {
    this.state.graduatedArray.map((classRecord) => {
      classRecord.selected = false;
    });
    this.setState({
      graduatedArray: this.state.graduatedArray,
      graduatedVisible: false
    })
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }
  _graduatedModal() {
    return (
      <Modal
        className="graduated-modal"
        footer={[
          <Button key="back" onClick={this.onSelectOneGraduatedRole.bind(this)} type="primary">去查看</Button>,
        ]}
        title="查看毕业班级"
        visible={this.state.graduatedVisible}
        maskClosable={false}
        onCancel={this.hideModal.bind(this)}
      >
        <div className="graduated-modal">
          {this.state.graduatedArray.map((classRecord, index) => 
            <div className={"class-info" + (classRecord.selected ? " active" : "")} key={index} onClick={this.selectClassRecord.bind(this, index)}>
              {this.toolGraduatedDate(classRecord.associatObj.graduate_date)}毕业-{classRecord.associatObj.className}
            </div>
          )}
        </div>
      </Modal>
    )
  }


  render() {
    return (
      <div className="roles-index-page">
        {this.state.systemAdmin ? <div className="school-name">系统管理员</div> : ''}
        {this.state.systemAdmin ? <div className="school-role" onClick={this.onSelectOneRole.bind(this, this.state.systemAdmin)}><span className="role-label">系统</span>管理员</div> : ''}
        {this.state.schools.map((school, schoolIndex) => <div key={schoolIndex}>
          <div className="school-name">{school.schoolName}</div>
          <div>
            {school.admin.map((role) => <div key={role.key} className="school-role" onClick={this.onSelectOneRole.bind(this, role)}><span className="role-label">{role.associatName == 'school' ? '学校' : role.associatObj.gradename}</span>管理员</div>)}
          </div>
          <div>
            {school.teacher.map((role) => <div key={role.key} className="school-role" onClick={this.onSelectOneRole.bind(this, role)}><span className="role-label">{role.associatObj.className}</span>{role.associatObj.isClassAdmin ? '班主任' : '老师'}</div>)}
          </div>
          <div>
            {school.parent.map((role) => <div key={role.key} className="school-role" onClick={this.onSelectOneRole.bind(this, role)}><span className="role-label">{role.associatObj.fullName}</span>家长</div>)}
          </div>
        </div>)}
        {(this.state.graduatedArray && this.state.graduatedArray.length > 0) ? <div className="school-role" onClick={() => this.setState({graduatedVisible: true})}><span className="role-label">查看毕业班级</span></div> : ''}
        {this._graduatedModal()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/RolesIndexPage.jsx